export enum TransactionRole {
  CUSTOMER = "CUSTOMER",
  PROVIDER = "PROVIDER",
  ADMIN = "ADMIN"
}

export enum TransactionStage {
  FAVORITE = "FAVORITE",
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  MODIF = "MODIF",
  CONFIRMED = "CONFIRMED",
  ONGOING = "ONGOING",
  COMPLETED = "COMPLETED"
}

export enum AppointmentStatus  {
    PROPOSED = "PROPOSED",
    BUYER_RESC = "BUYER_RESC",
    SELLER_RESC = "SELLER_RESC",
    SCHEDULED = "SCHEDULED",
    CANCELLED = "CANCELLED"
};

export enum ServiceType  {
    BUY = "BUY",
    EXCHANGE = "EXCHANGE",
    SELL = "SELL",
    RENT  = "RENT",
    INTERMEDIATION = "INTERMEDIATION",
    REPAIR = "REPAIR",
    CONTROL = "CONTROL"
    //KEEP_WARRANTY = "KEEP_WARRANTY",
    //KEEP_PREVENTIVE = "KEEP_PREVENTIVE",
    // KEEP_SECURITY = "KEEP_SECURITY",
};

export enum AppointmentLocationMode  {
    REMOTE = "REMOTE",
    SELLER_LOCATION = "SELLER_LOCATION",
    CUSTOMER_LOCATION = "CUSTOMER_LOCATION",
    OTHER_LOCATION = "OTHER_LOCATION"
};

export enum KeyEventType  {
    CAR_UNAVAILABLE = "CAR_UNAVAILABLE",
    CUSTOMER_BOOKED = "CUSTOMER_BOOKED",
    PROVIDER_BOOKED = "PROVIDER_BOOKED"
};

export enum KeyEventSource  {
    CAR = "CAR",
    CUSTOMER = "CUSTOMER",
    PROVIDER = "PROVIDER",
    OWNER = "OWNER"
};

export enum ObjectClass  {
    CAR = "CAR",
    OFFER = "OFFER",
    DEALER = "DEALER"
};

export enum ConversationAction {
  CREATE = "CREATE",
}

export enum AppointmentAction {
  CREATE = "CREATE",
}

export enum PostingType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE"
}

export enum PostingSource {
    AFRIAUTOS = "AFRIAUTOS",
    WHATSAPP = "WHATSAPP",
    FACEBOOK = "FACEBOOK",
    LINKEDIN = "LINKEDIN",
    INSTAGRAM = "INSTAGRAM",
    TELEGRAM = "TELEGRAM",
    OTHER = "OTHER"
}

export enum PostingStatus {
    CREATED = "CREATED",
    PENDING = "PENDING",
    POSTED = "POSTED",
    CANCELLED = "CANCELLED"
}

/*
export interface ObjectActionItem {
  action: ProposalAction |  BookingAction | JobAction,
  title: string,
  icon?: string
};
*/
export class CommonBasicData{

    public static serviceTypes: any = [
        {
          code: ServiceType.BUY,
          title: "Achat"
        },
        {
          code: ServiceType.EXCHANGE,
          title: "Echange"
        },
        {
          code: ServiceType.SELL,
          title: "Vente"
        },
        {
          code: ServiceType.RENT,
          title: "Location"
        },
        {
          code: ServiceType.INTERMEDIATION,
          title: "Intermédiation"
        },
        {
          code: ServiceType.REPAIR,
          title: "Réparation"
        },
        {
          code: ServiceType.CONTROL,
          title: "Controle technique"
        }
        
        /*
        {
          code: ServiceType.KEEP_WARRANTY,
          title: "Controle de Garantie"
        },
        {
          code: ServiceType.KEEP_PREVENTIVE,
          title: "Controle Préventif"
        }, 
        {
          code: ServiceType.KEEP_SECURITY,
          title: "Controle sécurité"
        },
        */

        
    ];

    public static getServiceTypeTitle(code: string): string{

      //console.log(code)
      let ind = -1;
      ind = CommonBasicData.serviceTypes.findIndex((srv: any) => srv.code === code)

      return (ind >= 0) ? this.serviceTypes[ind].title : "";

    }


    public static locationModes: any = [
        {
          code: AppointmentLocationMode.REMOTE,
          title: "Au téléphone"
        },
        {
          code: AppointmentLocationMode.SELLER_LOCATION,
          title: "En agence"
        },
        {
          code: AppointmentLocationMode.CUSTOMER_LOCATION,
          title: "Chez le client"
        },
        {
          code: AppointmentLocationMode.OTHER_LOCATION,
          title: "Autre endroit (à préciser dans les détails)"
        }
    ];
}